import React, { useState } from 'react'
import { Faqs } from "../constants"
import Sectionbreak from './Sectionbreak'
import AnimatedSection from './common/AnimatedSection'

function FrequentlyAQ() {
  const [accordion, setAccordion] = useState(2)

  const toggleAccordion = (index) => {
    setAccordion(index === accordion ? -1 : index)
  }

  return (
    <AnimatedSection className="py-16 bg-gray-50">
      <Sectionbreak
       title='Frequently Asked '
       highlight='Questions'
       description=''
      />
      <div className="max-w-7xl mx-auto px-4">
        <div className="space-y-4">
          {Faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border border-teal-100 rounded-lg shadow-sm transition hover:shadow-md cursor-pointer"
              onClick={() => toggleAccordion(index)}
            >
              <div className="flex items-center justify-between p-5">
                <h3 className="text-lg font-medium text-teal-900">{faq.question}</h3>
                <span className="text-teal-600">
                  {accordion === index ? (
                    <i className="fas fa-minus-circle text-xl"></i>
                  ) : (
                    <i className="fas fa-plus-circle text-xl"></i>
                  )}
                </span>
              </div>
              {accordion === index && (
                <div className="px-5 py-5 text-gray-700 text-base leading-relaxed border-t border-teal-100">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default FrequentlyAQ
